module.exports = __webpack_public_path__ + "static/media/villa-dorada.816c49df.jpg";